<template>
	<el-dialog :title="showTitle" :visible.sync="dialogAddShow" width="60%" :before-close="handleClose"
		:close-on-click-modal="false">
		<el-form label-position="right" ref="addForm" :model="addForm" label-width="70px" class="postForm">
			<el-form-item label="教师名称:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.teacherName" auto-complete="off" class="formItem" size="small"
					maxLength="200" />
			</el-form-item>
			<el-form-item label="所属机构:" label-width="110px" class="notBlank">
				<el-select v-model="addForm.schoolId" placeholder="请选择" size="small" class="formItem">
						<el-option v-for="item in schoolDict" :key="item.id" :label="item.schoolName" :value="item.id">
						</el-option>
					</el-select>
			</el-form-item>
			<el-form-item label="用户名:" label-width="110px" class="notBlank">
				<el-input v-model="addForm.logName" auto-complete="off" class="formItem" size="small" maxLength="100" />
			</el-form-item>
			<el-form-item label="密码:" label-width="110px" prop="password" class="notBlank">
				<el-input v-model="addForm.logPwd" auto-complete="off" class="formItem" size="small" maxLength="50" :disabled="addForm.isEditPwd==0"/>
				<span style="color:#606266;padding-left: 10px" v-if="addForm.id>0"><el-checkbox v-model="addForm.isEditPwd" :true-label="1"
							:false-label="0"></el-checkbox> 修改</span>
			</el-form-item>
			<el-form-item label="联系电话:" label-width="110px">
				<el-input v-model="addForm.linkTel" auto-complete="off" class="formItem" size="small" maxLength="100" />
			</el-form-item>
			<el-form-item label="在职状态:" label-width="110px">
				<el-checkbox v-model="statusCheck"></el-checkbox>
			</el-form-item>

		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="handleClose()" size="small">取 消</el-button>
			<el-button type="primary" @click="handleSubmit()" size="small">确 定</el-button>
		</div>
	</el-dialog>

</template>
<script>
export default {
	name: "addSave",
	props: ["showTitle", "dialogAddShow", "mid"],
	data() {
		return {
			addForm: {
				id: 0,
				teacherName: '',
				schoolId: '',
				logName: '',
				logPwd: '',
				linkTel: '',
				addTime: '',
				status: 0,
				syncTime: '',
			},
			schoolDict:[],
			statusCheck:true
		};
	},
	watch: {
		dialogAddShow: {
			handler(newVal, oldVal) {
				if (newVal) {
					this.initData();
				}
			},
			deep: true
		}
	},
	methods: {
		initData() {
			this.$axios.get("/school/getteacherinfoinfo?id=" + this.mid + "&rnd=" + new Date().getTime())
				.then(res => {
					this.addForm = res.data.data;
					this.statusCheck=this.addForm.status==1
					if(this.addForm.id==0){
						this.addForm.schoolId=''
						this.statusCheck=true
						this.$set(this.addForm,"isEditPwd",1)
						this.addForm.status=1
					}
					else{
						this.$set(this.addForm,"isEditPwd",0)
						this.addForm.logPwd=''
					}
				});
		},
		handleClose() {
			this.$emit("getVisible", false);
		},
		handleSubmit() {
			this.addForm.status=this.statusCheck?1:0
			let formData = this.$util.jsonToForm(this.addForm);
			this.$axios.post("/school/teacherinfosave", formData).then(res => {
				if (res.data.status == 0) {
					this.$message("保存成功!");
					this.$emit("saveCallBack");
				} else {
					this.$message(res.data.msg);
				}
			});
		}
	},
	async created(){
		this.schoolDict=[...await this.getSchoolDict()]
	}
};
</script>

<style lang="less" scoped></style>
